import React from 'react'
import '../styles/Aside.css'
import { Link } from 'react-router-dom'
import contrast from '../assets/contrast.svg'
import palette from '../assets/palette.svg'
import simulation from '../assets/simulation.svg'
import contrastCircle from '../assets/contrast-circle.svg'

const Aside = ({isActive, isOpen, setIsOpen}) => {
  const date = new Date()

  const handleClick = () => {
    setIsOpen(false)
  }
  return (
    <aside className={isActive}>
        <nav style={{padding: "0"}} className='aside-nav'>
          <ul onClick={handleClick} className='aside-ul'>
            <li>
              <img src={simulation} alt="Simulation Icon" />
              <Link to='/' className='link'>Color Blind Simulator</Link>
            </li><hr />
            <li>
              <img src={contrast} alt="Contrast Icon" />
              <Link to='/color-contrast' className='link'>Color Contrast Ratio</Link>
            </li><hr />
            <li>
              <img src={contrastCircle} alt="WCAG contrast icon" />
              <Link to='/wcag-contrast-ratio' className='link'>WCAG Contrast Ratio</Link>
            </li><hr />
            <li>
              <img src={palette} alt="Palette Icon" />
              <Link to='/color-palette' className='link'>Pick Color Palette</Link>
            </li><hr />
          </ul>
        </nav>
        <footer>Copyright &copy; {date.getFullYear()} CodeTesco</footer>
    </aside>
  )
}

export default Aside